import React, { useState, useEffect } from 'react';
import { Container, Grid, FormControl, Select, MenuItem } from '@mui/material';
import { useGlobal } from '../contexts/GlobalContext';
import StoriesQueryColumn from '../stories/StoriesQueryColumn';
import StoriesResultsColumn from '../stories/StoriesResultsColumn';
import StoriesInfoColumn from '../stories/StoriesInfoColumn';

const StoriesService = () => {
  const [selectedEngine, setSelectedEngine] = useState('');
  const { setCurrentContext } = useGlobal();

  useEffect(() => {
    setCurrentContext({
      product: 'build',
      page: 'stories',
      ...(selectedEngine && { engine: selectedEngine }),
    });
    return () => setCurrentContext(null);
  }, [selectedEngine, setCurrentContext]);

  const handleEngineChange = (event) => {
    setSelectedEngine(event.target.value);
  };

  const engineOptions = [
    { value: 'polymarket_v2', label: 'Polymarket V2' },
    { value: 'kalshi_v1', label: 'Kalshi V1' },
    { value: 'token_items_v1', label: 'Token Items V1' },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      <Grid container spacing={2} sx={{ height: 'calc(100vh - 120px)' }}>
        {/* Engine Selection */}
        <Grid size={{ xs: 12, md: 3 }}>
          <FormControl fullWidth variant="outlined" size="small" sx={{ mb: 2 }}>
            <Select
              value={selectedEngine}
              onChange={handleEngineChange}
              sx={{
                bgcolor: 'background.paper',
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    bgcolor: 'background.paper',
                  },
                },
              }}
            >
              {engineOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Query Column */}
          <StoriesQueryColumn selectedEngine={selectedEngine} />
        </Grid>

        {/* Results Column */}
        <Grid size={{ xs: 12, md: 6 }}>
          <StoriesResultsColumn />
        </Grid>

        {/* Info Column */}
        <Grid size={{ xs: 12, md: 3 }}>
          <StoriesInfoColumn />
        </Grid>
      </Grid>
    </Container>
  );
};

export default StoriesService;

